import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ConfigProviderService } from '../config-provider/config-provider.service';

@Injectable({
    providedIn: 'root',
})
export class GameTileBrandingEnablerService {
    constructor(
        private readonly configProviderService: ConfigProviderService,
        private readonly activatedRoute: ActivatedRoute,
    ) {}

    isEnabled() {
        const featureConfig = this.configProviderService.provideFeaturesConfig();
        const enablerValueInQuery =
            this.activatedRoute.snapshot.queryParamMap.get(featureConfig.experimental?.gameTileBranding?.queryParamName) ?? 'false';
        return featureConfig.experimental?.gameTileBranding?.enabled && enablerValueInQuery === 'true';
    }

    getIconTemplatePathForProvider(providerId: string) {
        if (providerId) {
            const featureConfig = this.configProviderService.provideFeaturesConfig();
            if (featureConfig.experimental?.gameTileBranding?.templatePathSelector?.providers?.length > 0) {
                if (
                    featureConfig.experimental.gameTileBranding.templatePathSelector.providers.find(
                        (provider: string) => provider.trim().toLowerCase() === providerId.trim().toLowerCase(),
                    )
                ) {
                    return featureConfig.experimental.gameTileBranding.iconPathTemplate;
                }
            }
        }
        return '';
    }

    getIconTemplatePathForGame(gameId: string) {
        if (gameId) {
            const featureConfig = this.configProviderService.provideFeaturesConfig();
            if (featureConfig.experimental?.gameTileBranding?.templatePathSelector?.games?.length > 0) {
                if (
                    featureConfig.experimental.gameTileBranding.templatePathSelector.games.find(
                        (game: string) => game.trim().toLowerCase() === gameId.trim().toLowerCase(),
                    )
                ) {
                    return featureConfig.experimental.gameTileBranding.iconPathTemplate;
                }
            }
        }
        return '';
    }

    splitNameInSpansFor(gameId: string): boolean {
        if (gameId) {
            const featureConfig = this.configProviderService.provideFeaturesConfig();
            const isNameSplittingEnabledInConfig = featureConfig.experimental?.gameTileBranding?.nameSplitting?.enabled;
            const spansForInQuery = this.activatedRoute.snapshot.queryParamMap.getAll('splitSpansFor');
            const spansForInConfig: string[] = featureConfig.experimental?.gameTileBranding?.nameSplitting?.spansFor?.games;
            const spansFor: string[] = [...(spansForInConfig ?? []), ...spansForInQuery];
            if (isNameSplittingEnabledInConfig && spansFor.length > 0) {
                if (spansFor.find((game: string) => game.trim().toLowerCase() === gameId.trim().toLowerCase())) {
                    return true;
                }
            }
        }
        return false;
    }
}
